import moment from "moment-timezone";

export const fetchScheduleData = async (payload) => {

  //configured api url
  const apiUrl = global.config.routingServiceUrl + "/cargorouting/getRoutes";

  const body = {
    "origin": payload.origin,
    "destination": payload.destination,
    "serviceLevel": payload.serviceLevel
  };

  let shipDate;

  let originFacility = payload.nonRevAndRevFacilities.find(facility => {
    return facility.airportCodeIATA === payload.origin;
  });

  let destFacility = payload.nonRevAndRevFacilities.find(facility => {
    return facility.airportCodeIATA === payload.destination;
  });

  if (payload.departOrArrive === "depart") {
    shipDate = moment.tz(payload.date + "T" + payload.time, originFacility.olsonTimeZone);
    body.shipDate = shipDate.format();
  } else {
    shipDate = moment.tz(payload.date + "T00:00:00", originFacility.olsonTimeZone);

    let pickUpDate = moment.tz(payload.date + "T" + payload.time, destFacility.olsonTimeZone);

    shipDate = moment(shipDate).isAfter(pickUpDate) ? pickUpDate : shipDate;

    body.shipDate = shipDate.format();
    body.pickUpDate = pickUpDate.format();
  }
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': global.config.apiKey
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const data = await response.json();
  return {
    routes: data.routes.route,
    segmentTypes: data.segmentTypes || []
  };
};



// WEBPACK FOOTER //
// ./src/api/scheduleDataApi.js